export default __webpack_public_path__ + "static/media/Loading-03-03.45eb5c16.png";